<template>
  <div class="select">
    <el-select v-model="value" multiple placeholder="" style="width: 100%" @change="changeValue" :disabled="formData.disabled">
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.nameChi + ' ' + item.id"
        :value="item.id + ''"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      value: [],
      options: [],
    };
  },
  watch: {
    value: {
      handler() {
        // if (this.value.length > 0) {
        //   this.$emit("change", this.value);
        // }
      },
      deep: true,
      immediate: true,
    },
    formData: {
      handler() {
        if (this.formData.shopIds && this.formData.shopIds.length > 0) {
          this.value = this.formData.shopIds;
        }
        // console.log(this.formData, 111111);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    changeValue(e) {
      this.$emit("change", e);
    },
    getShop() {
      this.ccRequest
        .do("admin/merchant/shop/queryAllByMerchantNum", {
          merchantNum: this.$shopData.merchantNum,
        })
        .then((res) => {
          this.options = res;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.getShop();
  },
};
</script>

<style lang="scss" scoped>
.select {
  width: 100%;
}
</style>
